$(function () {
	if ($(".hm_hero_slick").length > 0) {
		$(".hm_hero_slick").slick({
			autoplay: true,
			arrows: true,
			speed: 500,
			dots: false,
			infinite: true,
			slidesToShow: 1,
			nextArrow: "<span class='btn_next'><i class='icon-arrow-right'></i></span>",
			prevArrow: "<span class='btn_prev'><i class='icon-arrow-left'></i></span>",
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						arrows: false,
						dots: true,
					},
				},
				{
					breakpoint: 830,
					settings: {
						arrows: false,
						dots: true,
					},
				},
				{
					breakpoint: 480,
					settings: {
						arrows: false,
						dots: true,
					},
				},
			],
		});
	}

	if ($(".clients_section").length > 0) {

		$(".client_slick").slick({
			autoplay: true,
			speed: 1500,
			arrows: false,
			dots: true,
			infinite: true,
			slidesToShow: 5,
			slidesToScroll: 2,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 830,
					settings: {
						arrows: true,
						nextArrow: "<span class='btn_next'><i class='icon-arrow-right'></i></span>",
						prevArrow: "<span class='btn_prev'><i class='icon-arrow-left'></i></span>",
						dots: false,
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 480,
					settings: {
						arrows: true,
						nextArrow: "<span class='btn_next'><i class='icon-arrow-right'></i></span>",
						prevArrow: "<span class='btn_prev'><i class='icon-arrow-left'></i></span>",
						dots: false,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});
	}


	if ($(".bundles_slick_corp").length > 0) {

		$(".bundles_slick_corp").slick({
			arrows: true,
			nextArrow: "<span class='btn_next'><i class='icon-arrow-right'></i></span>",
			prevArrow: "<span class='btn_prev'><i class='icon-arrow-left'></i></span>",
			dots: false,
			infinite: true,
			slidesToShow: 4,
			slidesToScroll: 4,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						autoplay: true,
						speed: 500,
						// dots: true,
						infinite: true,
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 830,
					settings: {
						autoplay: true,
						speed: 500,
						infinite: true,
						// dots: true,
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 480,
					settings: {
						autoplay: true,
						speed: 500,
						infinite: true,
						// dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			],
		});

	}


	if ($('.review_slick').length > 0) {
		$(".review_slick").slick({
			arrows: false,
			centerMode: true,
			dots: false,
			infinite: false,
			slidesToShow: 3,
			autoplay: false,
			speed: 500,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						autoplay: true,
						speed: 500,
						dots: true,
						infinite: true,
						slidesToShow: 3,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 830,
					settings: {
						autoplay: true,
						speed: 500,
						infinite: true,
						dots: true,
						slidesToShow: 2,
						slidesToScroll: 1,
					},
				},
				{
					breakpoint: 480,
					settings: {
						autoplay: true,
						speed: 500,
						infinite: true,
						dots: true,
						slidesToShow: 1,
						slidesToScroll: 1,
					},
				},
			]
		});
	}

});
